import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { VayuBlocksBlockEditor } from '@vayu-blocks/global';
import { useState,useEffect} from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {BorderBoxControl} from '@wordpress/components';

export const Bordercontrol = ({onChange,dataKey,frameData}) => {

    const [colors, setColors] = useState([]);
    const deviceView  = VayuBlocksDevice();
    const blockEditor = VayuBlocksBlockEditor();
    const [firstTablet, setFirstTablet] = useState(false);
    const [firstDesktop, setFirstDesktop] = useState(true);

    // default border colors
    useEffect(() => {
         setColors([
         {
             colors: blockEditor.colors,
             name: 'THEME COLORS'
           },
         {
             colors:[
             {
               color: '#72aee6',
               name: 'Blue 20'
             },
             {
               color: '#3582c4',
               name: 'Blue 40'
             },
             {
               color: '#e65054',
               name: 'Red 40'
             },
             {
               color: '#8a2424',
               name: 'Red 70'
             },
             {
               color: '#f2d675',
               name: 'Yellow 10'
             },
             {
               color: '#bd8600',
               name: 'Yellow 40'
             }],
             name: 'Default'
         }
           ]);
    }, [blockEditor]);

    const handleBorderChangeTest = (frameData, newBorders) => {

      const attr = frameData.border;

      // Ensure border object exists before updating
      const updatedAttributes = {
          ...frameData, // Spread existing frameData
          border: {
              ...frameData.border, // Preserve existing border properties
              [deviceView]: newBorders, // Update only the border for the current deviceView
          },
      };
    
      // Check if it's the first time running on this device view
      const isFirstRun = attr?.[deviceView] === undefined;
      const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

      // Device view specific logic
      if (deviceView === 'Desktop') {
          if (isFirstRun || firstDesktop) {
              Object.assign(updatedAttributes.border, { Tablet: newBorders, Mobile: newBorders });
              localStorage.setItem('firstTablet', 'true'); // Ensure value is string in localStorage
              setFirstTablet(true);
              setFirstDesktop(true);
          }
      } else if (deviceView === 'Tablet') {
          if (isTabletFirstRun) {
              Object.assign(updatedAttributes.border, { Mobile: newBorders });
              localStorage.removeItem('firstTablet'); // Reset localStorage item when Tablet is accessed
              setFirstTablet(true);
              setFirstDesktop(false);
          }
      } else {
          // For other device views, reset tablet/desktop flags
          setFirstTablet(false);
          setFirstDesktop(false);
      }
      
        onChange(dataKey, updatedAttributes);
    };
    
  return (
        <>
            <BorderBoxControl
             __next40pxDefaultSize
                label={__('Border', 'vayu-blocks')}
                onChange={(newValue) =>handleBorderChangeTest(frameData,newValue) }
                value={frameData?.border[deviceView]}
                colors={colors}
            />
        </>
  )
}

 